import { HeaderWrapper, Separator } from "./styles"

export const Header = (props) => {
    return (
        <HeaderWrapper>
            <h1>{props.children}</h1>
            <Separator />
        </HeaderWrapper>
    )
}